import { render, staticRenderFns } from "./ModelDemo.vue?vue&type=template&id=0eb8a209&scoped=true&"
import script from "./ModelDemo.vue?vue&type=script&lang=js&"
export * from "./ModelDemo.vue?vue&type=script&lang=js&"
import style0 from "./ModelDemo.vue?vue&type=style&index=0&id=0eb8a209&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb8a209",
  null
  
)

export default component.exports